import React from "react";
import { string } from "prop-types";

import { DfpComponent } from "../../../ads/dfp-component";
import DfpContainer from "../../../ads/dfp-container";
import { Widgets } from "../../../widgets";

import { getSlotId } from "../../../utils/utils";

import "./organism3.m.css";

const Organism3 = ({ widgetUrl = null, widgetHeight = null, collectionSlug, adSlot = "", layoutName }) => {
  return (
    <div styleName="base">
      <DfpContainer styleName="r1-ad">
        <DfpComponent
          collectionSlug={collectionSlug}
          type={adSlot}
          slotId={getSlotId(adSlot, collectionSlug)}
          layoutName={layoutName}
        />
      </DfpContainer>
      <div id={`${collectionSlug}-widget`}>
        {widgetUrl && (
          <Widgets widgetUrl={widgetUrl} widgetHeight={widgetHeight} widgetStyles="five-stories-1ad-widget" />
        )}
      </div>
    </div>
  );
};

Organism3.propTypes = {
  widgetUrl: string,
  widgetHeight: string,
  collectionSlug: string,
  adSlot: string,
  layoutName: string,
};

export default Organism3;
